/* eslint-disable react/prop-types */
import React from 'react';
import { Sparkles } from 'lucide-react';

/**
 * Visual ladder of the 12 perception states. Highlights the current state,
 * dims previous, ghosts upcoming. Read-only — transitions happen via the
 * counselor's perception tracker form.
 */
export default function PerceptionLadder({ states, currentCode, onSelect, suggestionCode }) {
  if (!states || !states.length) return null;
  const currentIdx = Math.max(0, states.findIndex(s => s.code === currentCode));

  return (
    <div data-testid="perception-ladder" className="rounded-2xl border border-[#EBE8E3] bg-[#FBFaf9] p-5">
      <div className="flex items-center gap-2 mb-4">
        <Sparkles className="w-3.5 h-3.5 text-[#8C6239]" strokeWidth={1.5} />
        <span className="text-[10px] uppercase tracking-[0.18em] text-[#8A8681] font-['Work_Sans']">
          Perception ladder
        </span>
      </div>

      <ol className="space-y-1.5">
        {states.map((s, i) => {
          const past = i < currentIdx;
          const at = i === currentIdx;
          const ahead = i > currentIdx;
          const isSuggestion = s.code === suggestionCode && !at;

          const baseCls = at
            ? 'border-[#4A5D4E] bg-[#4A5D4E] text-white'
            : past
              ? 'border-[#D8D4CE] bg-white text-[#5C5955]'
              : 'border-dashed border-[#EBE8E3] bg-transparent text-[#B5B0A8]';
          const ringCls = isSuggestion ? 'ring-2 ring-[#8C6239] ring-offset-1 ring-offset-[#FBFaf9]' : '';

          return (
            <li key={s.code}>
              <button
                type="button"
                data-testid={`perception-rung-${s.code}`}
                onClick={onSelect ? () => onSelect(s.code) : undefined}
                className={`group w-full text-left rounded-full border px-4 py-2 transition-all ${baseCls} ${ringCls} ${onSelect ? 'hover:border-[#4A5D4E]' : ''}`}
              >
                <div className="flex items-center gap-3">
                  <span className={`text-[10px] tabular-nums w-5 ${at ? 'text-white/70' : ahead ? 'text-[#B5B0A8]' : 'text-[#8A8681]'}`}>
                    {String(i + 1).padStart(2, '0')}
                  </span>
                  <span className={`text-sm font-['Work_Sans'] ${at ? 'font-medium' : ''}`}>
                    {s.label}
                  </span>
                  {isSuggestion && (
                    <span data-testid={`perception-suggestion-${s.code}`}
                          className="ml-auto text-[10px] uppercase tracking-[0.16em] text-[#8C6239] bg-[#FAF1E1] border border-[#E5D6BE] rounded-full px-2 py-0.5">
                      Suggested
                    </span>
                  )}
                  {at && !isSuggestion && (
                    <span className="ml-auto text-[10px] uppercase tracking-[0.16em] text-white/80">
                      Current
                    </span>
                  )}
                </div>
              </button>
            </li>
          );
        })}
      </ol>
    </div>
  );
}
